/**
 * Descripción: Gestor de Rutas de las vistas
 *
 * @displayName path
 */

import Main from '@/views/Main/router';
import LoginRoutes from '@/views/Login/router';
import ErrorsRoutes from '@/views/Error/router';

/**
 * Se obtienen rutas de las vistas
 */
const routes = [...Main, ...LoginRoutes, ...ErrorsRoutes];

routes.forEach(filter);

/**
 * asignar lazyload y rutas hijas
 */
function filter(item) {
  if (item.component != undefined) {
    item.component = lazyLoad(item.component);
  }

  //recursiva
  if (item.children != undefined) {
    item.children.forEach(filter);
  }
}

/**
 * lazy load
 */
function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`);
}

export default routes;
